enum EventTypes {
  AppRouteChanged = 4,
  AppButtonClicked = 5,
}

export default EventTypes;
